import { Divider, MenuItem, Stack, Typography } from "@mui/material";
import { BubbleChartItem } from "./StackChartBtn";

export const BubbleLegendBlock = ({
  handleLegendClick,
  selectedRole,
  roles,
  average_coverage,
}: {
  selectedRole: string;
  handleLegendClick: (role: string) => void;
  roles: BubbleChartItem[];
  average_coverage: number;
}) => {
  return (
    <Stack paddingTop={"10px"}>
      <Stack
        sx={{
          flexDirection: "row",
          gap: "12px",
          alignItems: "center",
          padding: "16px",
          border: "1px solid #DEDEDE",
          borderRadius: "8px",
        }}
      >
        <Typography variant={"body1"} sx={{ color: "#585858" }}>
          Average role coverage
        </Typography>
        <Divider orientation={"vertical"} flexItem={true} />
        <Stack
          sx={{
            flexDirection: "row",
            gap: "8px",
            alignItems: "center",
          }}
        >
          <Typography
            variant={"subtitle1"}
            sx={{ color: "#232323", fontWeight: 500 }}
          >
            {average_coverage}%
          </Typography>
          <Typography variant={"body1"} sx={{ color: "#232323" }}>
            across all roles
          </Typography>
        </Stack>
      </Stack>
      <Stack
        minWidth="386px"
        maxWidth="386px"
        gap="8px"
        padding="20px 8px"
        flexShrink={0}
      >
        <Stack sx={{ padding: "0 8px", flexDirection: "row" }}>
          <Typography sx={{ color: "#1F293299", minWidth: "162px" }}>
            Role
          </Typography>
          <Typography
            sx={{ color: "#1F293299", textAlign: "center", minWidth: "120px" }}
          >
            Identified/Goal
          </Typography>
          <Typography
            sx={{ color: "#1F293299", textAlign: "center", minWidth: "88px" }}
          >
            Coverage
          </Typography>
        </Stack>
        <Stack
          onMouseLeave={() => handleLegendClick("")}
          gap={"6px"}
          width={"100%"}
        >
          {roles.map(({ role, color, label, expected, actual, coverage }) => (
            <MenuItem
              onMouseEnter={() => handleLegendClick(label)}
              key={role}
              sx={{ padding: "4px 8px" }}
              selected={selectedRole === role}
            >
              <Stack flexDirection="row" justifyContent="space-between">
                <Stack flexDirection="row" alignItems="center" gap="12px">
                  <span
                    style={{
                      backgroundColor: color,
                      width: "12px",
                      height: "12px",
                    }}
                  />
                  <Typography sx={{ color: "#121212", width: "140px" }}>
                    {label}
                  </Typography>
                </Stack>

                <Stack
                  flexDirection="row"
                  justifyContent="flex-end"
                  gap={"16px"}
                >
                  <Typography
                    variant={"body1"}
                    sx={{
                      color: "#121212",
                      textAlign: "center",
                      minWidth: "116px",
                    }}
                  >
                    {actual}/{expected}
                  </Typography>
                  <Typography
                    variant={"body1"}
                    sx={{
                      lineHeight: "20px",
                      color: "#121212",
                      textAlign: "left",
                    }}
                  >
                    {coverage}%
                  </Typography>
                </Stack>
              </Stack>
            </MenuItem>
          ))}
        </Stack>
        <Stack gap={"8px"} paddingLeft={"8px"}>
          <Typography sx={{ color: "#1F293299", textAlign: "left" }}>
            Chart Indicators
          </Typography>
          <Stack flexDirection="row" alignItems="flex-start" gap="12px">
            <span
              style={{
                width: "12px",
                borderTop: "4px solid #FE8836",
                marginTop: "8px",
              }}
            />
            <Typography sx={{ color: "#121212" }}>
              Discovery Goal by Role
            </Typography>
          </Stack>
          <Stack flexDirection="row" alignItems="center" gap="12px">
            <span
              style={{
                width: "12px",
                height: "12px",
                border: "1px solid #797979",
                background: `
      repeating-linear-gradient(
        45deg,
        #797979,
        #797979 1px,
        transparent 1px,
        transparent 3px
      )
    `,
              }}
            />
            <Typography sx={{ color: "#121212" }}>
              Role Overrepresentation
            </Typography>
          </Stack>
          <Stack flexDirection="row" alignItems="center" gap="12px">
            <span
              style={{
                width: "12px",
                height: "12px",
                border: "1px dashed #797979",
              }}
            />
            <Typography sx={{ color: "#121212" }}>
              Role Underrepresentation
            </Typography>
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
};
